export default __webpack_public_path__ + "static/media/093-down-arrow-4.73b3663b.png";